(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[26085],{

/***/ 48986:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/ModalBlankWide",
      function () {
        return __webpack_require__(40814);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 40814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_Transition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1193);
/* harmony import */ var constant_url__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99741);
/* harmony import */ var constant_url__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(constant_url__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47041);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(cookies_next__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);





function ModalBlank(param) {
    var children = param.children, id = param.id, modalOpen = param.modalOpen, setModalOpen = param.setModalOpen;
    var modalContent = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    // // close on click outside
    // useEffect(() => {
    //   const clickHandler = ({ target }) => {
    //     if (!modalOpen || modalContent.current.contains(target)) return
    //     setModalOpen(false)
    //     setCookies('editor_notification_popup', true, {
    //       domain: cookies_domain_name,
    //       path: '/',
    //     })
    //   }
    //   document.addEventListener('click', clickHandler)
    //   return () => document.removeEventListener('click', clickHandler)
    // })
    // close if the esc key is pressed
    // useEffect(() => {
    //   const keyHandler = ({ keyCode }) => {
    //     if (!modalOpen || keyCode !== 27) return
    //     setModalOpen(false)
    //     setCookies('editor_notification_popup', true, {
    //       domain: cookies_domain_name,
    //       path: '/',
    //     })
    //   }
    //   document.addEventListener('keydown', keyHandler)
    //   return () => document.removeEventListener('keydown', keyHandler)
    // })
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utils_Transition__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                className: "fixed inset-0 z-50 ",
                show: modalOpen,
                enter: "transition ease-out duration-200",
                enterStart: "opacity-0",
                enterEnd: "opacity-100",
                leave: "transition ease-out duration-100",
                leaveStart: "opacity-100",
                leaveEnd: "opacity-0",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utils_Transition__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                id: id,
                className: "fixed inset-0 z-50 overflow-hidden flex items-center my-4 justify-center transform px-4 sm:px-6",
                role: "dialog",
                "aria-modal": "true",
                show: modalOpen,
                enter: "transition ease-in-out duration-200",
                enterStart: "opacity-0 translate-y-4",
                enterEnd: "opacity-100 translate-y-0",
                leave: "transition ease-in-out duration-200",
                leaveStart: "opacity-100 translate-y-0",
                leaveEnd: "opacity-0 translate-y-4",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    ref: modalContent,
                    className: "bg-white rounded overflow-auto max-w-3xl w-full max-h-full",
                    children: children
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (ModalBlank);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [49774,92888,40179], function() { return __webpack_exec__(48986); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);